import { Component, OnInit } from "@angular/core";
import { Card } from "./../../models/card";
import { Memorygame } from "../../models/game";
import { DeckService } from "./deck.service";

@Component({
  selector: "memory",
  templateUrl: "./memory-table.component.html",
  styleUrls: ["./memory-table.component.css"]
})
export class MemoryTableComponent implements OnInit {
  game: Memorygame;
  card: Card;
  show: boolean;

  constructor(private _deckservice: DeckService) {
    this.startGame(); // to display the deck of card when loading the page
  }

  ngOnInit() {}

  startGame() {
    this.game = new Memorygame(this.deck);
  }

  selectCard(card: Card) {
    this.game.selectCard(card);
  }

  deck = [
    //following the model in the card.ts
    {
      name: "1",
      image: "../../assets/goals/1.png",
      flipped: false,
      message:
        "NO POVERTY: Eradicating poverty in all its forms remains one of the greatest challenges facing humanity."
    },
    {
      name: "2",
      image: "../../assets/goals/2.png",
      flipped: false,
      message:
        "ZERO HUNGER:  extreme hunger and malnutrition remain a huge barrier to development in many countries."
    },
    {
      name: "3",
      image: "../../assets/goals/3.jpg",
      flipped: false,
      message: "SUNDHED OG TRIVSEL:  good health and well-being"
    },
    {
      name: "4",
      image: "../../assets/goals/4.png",
      flipped: false,
      message:
        "QUALITY EDUCATION: Achieving inclusive and quality education for all"
    },
    {
      name: "5",
      image: "../../assets/goals/5.png",
      flipped: false,
      message:
        "GENDER EQUALITY: Ending all forms of discrimination against women and girls."
    },
    {
      name: "8",
      image: "../../assets/goals/8.png",
      flipped: false,
      message:
        "DECENT WORK AND ECONOMIC GROWTH - International Labour Organization: more than 204 million people were unemployed in 2015."
    },
    {
      name: "10",
      image: "../../assets/goals/10.png",
      flipped: false,
      message:
        "REDUCED INEQUALITIES: The poorest 10 percent earn only between 2 percent and 7 percent of total global income."
    },

    {
      name: "13",
      image: "../../assets/goals/13.jpg",
      flipped: false,
      message:
        "KLIMA-INDSATS: Take urgent action to combat climate change and its impacts"
    },
    {
      name: "16",
      image: "../../assets/goals/16.png",
      flipped: false,
      message:
        "PEACE, JUSTICE AND STRONG INSTITUTIONS:  Sexual violence, crime, exploitation and torture are also prevalent where there is conflict or no rule of law."
    },
    {
      name: "17",
      image: "../../assets/goals/17.png",
      flipped: false,
      message:
        "PARTNERSHIPS FOR THE GOALS: The world today is more interconnected - share ideas and foster innovation."
    }
  ];
}
